export const IdentificationType = {
    CITIZEN_CARD: 'CITIZEN_CARD',
    IDENTITY_CARD: 'IDENTITY_CARD',
    RESIDENCE_TITLE: 'RESIDENCE_TITLE',
    PASSPORT: 'PASSPORT',

    values: () => {
        return ['CITIZEN_CARD', 'IDENTITY_CARD', 'RESIDENCE_TITLE', 'PASSPORT'];
    }
}